import { render, staticRenderFns } from "./ReceptionContactDetailEditor.vue?vue&type=template&id=002b2338&scoped=true&"
import script from "./ReceptionContactDetailEditor.vue?vue&type=script&lang=ts&"
export * from "./ReceptionContactDetailEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionContactDetailEditor.vue?vue&type=style&index=0&id=002b2338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002b2338",
  null
  
)

export default component.exports